var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function IndexConcepts(el) {
	var $el = $(el),
      	$conceptsNav = $el.find('#concepts-nav'),
      	$conceptsItems = $el.find('#concepts-nav li'),
      	$firstConceptsItem = $el.find('#concepts-nav li:first-child'),
      	$conceptsTabContent = $el.find('.concepts-tab-content'),
      	$firstConceptsTabContent = $el.find('.concepts-tab-content:first'),
      	$share = $el.find('.share-icon'),
      	$copyConfirmation = $el.find('.copy-confirmation');
      	$toggle = $el.find('.subnav__default');

	$toggle.on('click', function() {
	    $(this).toggleClass('open');
	    $(this).next().toggleClass('open');
	});

    if (!location.hash) {
    	$conceptsTabContent.hide();
		$firstConceptsItem.addClass('active');
		$firstConceptsTabContent.show();
		var href = $firstConceptsItem.find('a').attr('href');
		if(history.replaceState) {
			history.replaceState(null, null, href);
		}
		else {
			window.location.hash = href;
		}   
    } else {
    	$(window).scrollTop(0);
    	updateTab();
    }

    $conceptsItems.click(function(){
	    $conceptsItems.removeClass('active');
	    $(this).addClass('active');
	    $conceptsTabContent.hide();	    
	    var activeTab = $(this).find('a').attr('href');
	    $(activeTab).fadeIn();
	    if(history.replaceState) {
			history.replaceState(null, null, activeTab);
		}
		else {
			window.location.hash = activeTab;
		}   
	    return false;
  	});

  	var $temp = $("<input>");

	$share.on('click', function() {
		var $url = $(location).attr('href');
	  	$('body').append($temp);
	  	$temp.val($url).select();
	  	document.execCommand('copy');
	  	$temp.remove();
	  	$copyConfirmation.html('URL Copied!')

	  	setTimeout(function(){ $copyConfirmation.html("") }, 3000);
	})

  	function updateTab() {
  		$conceptsItems.each(function (index, li) {
		  	var tab = $(li).find('a').attr('href');
		    if (tab == location.hash) {
		    	$conceptsItems.removeClass('active');
		    	$conceptsTabContent.hide();
		    	$(li).addClass('active')
		      	$(tab).fadeIn();
		      	return false;
		    }
		});
  	}
}

module.exports = IndexConcepts;
